import {
  FACET_KEYS,
  MVP_FACET_KEYS,
  buildClearQueryParams,
  clearKeysFor,
  facetFor,
} from 'client-portal/utils/clinicianSearch/facets/manifest';
import Service, { service } from '@ember/service';

export default class ClinicianSearchFacetNamesService extends Service {
  @service intl;
  @service store;
  @service clinicianSearch;

  get names() {
    return this.clinicianSearch.isDiscoveryEnabled ? FACET_KEYS : MVP_FACET_KEYS;
  }

  baseLabel(facetName) {
    return this.intl.t(`booking.clinicianSearch.filters.${facetName}`);
  }

  pillDetails(facetName) {
    let query = this.clinicianSearch.query;
    let facet = facetFor(facetName);
    let baseLabel = this.baseLabel(facetName);
    let count = facet?.pill?.count?.(query, this) ?? 0;
    let strategyActiveText = facet?.pill?.text?.(query, this) ?? '';
    let isSelected = !!strategyActiveText || count > 0;
    let showCount = !strategyActiveText && count > 0;
    let label = strategyActiveText || baseLabel;
    let activeText = strategyActiveText || (count > 0 ? String(count) : '');

    return {
      facetName,
      baseLabel,
      label,
      activeText,
      isSelected,
      count,
      showCount,
      clearAriaLabel: this.intl.t('booking.clinicianSearch.filterDetail.clearFilterPillAria', {
        filterLabel: baseLabel,
      }),
      clearQueryParams: buildClearQueryParams(clearKeysFor(facetName)),
    };
  }
}
